import React, { useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./Integrations.css";

import Loader from "../../components/Loader/Loader";
import { Link } from "react-router-dom";

import { UserContext } from "../../App.js";
import Einstein from "../../components/Einstein/Einstein.js";
import { TypeAnimation } from "react-type-animation";

export default function Dashboard(props) {
    const { user, setUser, integrations } = useContext(UserContext);

    const integrationTypes = {
        0: { name: "Bling", url: "bling" },
        1: { name: "Mercado Livre", url: "meli" },
    };

    const [modalAdd, setModalAdd] = useState(false);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [modalWaiting, setModalWaiting] = useState(false);

    const [blingConfig, setBlingConfig] = useState(false);
    const [addMarketplace, setAddMarketplace] = useState(false);

    const [integration, setIntegration] = useState({});

    const [marketplaceData, setMarketplaceData] = useState({ marketplace: 1 });

    const [modalIntegration, setModalIntegration] = useState({});

    const [integrationsArray, setIntegrationsArray] = useState([]);

    const [addMarketplaceLoading, setAddMarketplaceLoading] = useState(false);

    useEffect(() => {
        console.log(Object.values(integrations));
        setIntegrationsArray(Object.values(integrations));
    }, [integrations]);

    const marketplaces = [
        { id: 1, name: "Mercado Livre", icon: "ml.svg", maxLength: 60 },
        { id: 2, name: "Magalu", icon: "magalu3.svg", maxLength: 120 },
        { id: 3, name: "Amazon", icon: "amazon2.svg", maxLength: 60 },
        { id: 4, name: "Olist", icon: "olist2.svg", maxLength: 60 },
        { id: 5, name: "B2W", icon: "b2w.svg", maxLength: 120 },
        { id: 6, name: "Shopee", icon: "shopee.svg", maxLength: 120 },
        { id: 7, name: "Netshoes", icon: "netshoes.svg", maxLength: 100 },
        { id: 0, name: "Outros", icon: "outros5.svg", maxLength: 120 },
    ];

    return (
        <>
            <div className={`integrations-modal-bg ${blingConfig ? "shown" : ""}`} onClick={() => setBlingConfig(false)}>
                <div className="integrations-bling-modal" onClick={(ev) => ev.stopPropagation()}>
                    {blingConfig ? (
                        integration?.config2?.length ? (
                            <div className="integration-marketplace-explanation" key={0}>
                                <Einstein className="instegrations-einstein" type="say" />
                                <TypeAnimation
                                    className="integration-saying"
                                    sequence={[
                                        1500,
                                        "Caso venda em outros marketplaces, não esqueça de adicioná-los, para que eu todos seus pedidos e produto sejam integrados automaticamente!",
                                    ]}
                                    speed={{
                                        type: "keyStrokeDelayInMs",
                                        value: 10,
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="integration-marketplace-explanation" key={1}>
                                <Einstein className="instegrations-einstein" type="say" />
                                <TypeAnimation
                                    className="integration-saying"
                                    sequence={[
                                        1500,
                                        "Estou criando nossas categorias e campos customizados em seu Bling! Não os exclua em hipótese alguma, ou a integração não irá funcionar. É crucial que faça a conexão dos marketplaces corretamente, para que seus pedidos e produtos sejam integrados corretamente!",
                                    ]}
                                    speed={{
                                        type: "keyStrokeDelayInMs",
                                        value: 10,
                                    }}
                                />
                            </div>
                        )
                    ) : (
                        <></>
                    )}
                    <div
                        className="btn-add-marketplace"
                        onClick={() => {
                            setAddMarketplace(true);
                        }}
                    >
                        Adicionar marketplace
                    </div>
                    <div className="integration-marketplaces">
                        {integration?.config2?.map((e, i) => {
                            return (
                                <div className="integration-marketplace">
                                    <img src={"/places/" + marketplaces.find((m) => m.id === e.marketplace)?.icon} />
                                    <div className="integration-place-name">{e.name}</div>
                                    <div className="integration-place-code">
                                        Código Bling
                                        <span>{e.code}</span>
                                    </div>
                                    <div
                                        className="integration-place-remove"
                                        onClick={async () => {
                                            let newConfig = [...(integration?.config2 || [])] || [];
                                            newConfig.splice(i, 1);
                                            setIntegration({
                                                ...integration,
                                                config2: newConfig,
                                            });
                                            await fetch("/api/bling/removemarketplace", {
                                                method: "DELETE",
                                                body: JSON.stringify({
                                                    code: e.code,
                                                }),
                                                headers: {
                                                    "Content-Type": "application/json",
                                                },
                                            });
                                        }}
                                    >
                                        Remover
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div
                className={`integrations-modal-bg ${addMarketplace ? "shown" : ""}`}
                onClick={() => {
                    if (addMarketplaceLoading) return;
                    setAddMarketplace(false);
                    setMarketplaceData({ marketplace: 1 });
                }}
            >
                <div className="integrations-add-marketplace" onClick={(ev) => ev.stopPropagation()}>
                    <div className={`integrations-add-marketplace-loading ${addMarketplaceLoading ? "shown" : ""}`}>
                        <Loader />
                    </div>
                    <div className="integrations-marketplace-list">
                        {marketplaces.map((e) => {
                            return (
                                <div
                                    className={`integration-marketplace-btn ${
                                        marketplaceData.marketplace === e.id ? "selected" : ""
                                    }`}
                                    onClick={() =>
                                        setMarketplaceData({
                                            ...marketplaceData,
                                            marketplace: e.id,
                                        })
                                    }
                                >
                                    <img src={"/places/" + e.icon} />
                                </div>
                            );
                        })}
                    </div>
                    <div className="integrations-marketplace-data">
                        <label>
                            Nome do canal de venda:
                            <input
                                value={marketplaceData.name || ""}
                                onChange={(ev) => {
                                    setMarketplaceData({
                                        ...marketplaceData,
                                        name: ev.target.value.slice(0, 15),
                                    });
                                }}
                            />
                        </label>
                        <label>
                            Código da loja API Bling
                            <input
                                value={marketplaceData.code || ""}
                                onChange={(ev) => {
                                    setMarketplaceData({
                                        ...marketplaceData,
                                        code: ev.target.value.replace(/\D/g, "").slice(0, 12),
                                    });
                                }}
                            />
                            <a href="https://www.youtube.com/watch?v=ItlFsR6D_C4" target="_blank" className="codigo-bling">
                                Como consigo esse código?
                            </a>
                        </label>
                    </div>
                    <div
                        className="integration-marketplace-save"
                        onClick={async () => {
                            try {
                                if (!marketplaceData.name || !marketplaceData.code) return alert("Preencha tudo corretamente!");

                                setAddMarketplaceLoading(true);

                                const result = await fetch("/api/bling/addmarketplace", {
                                    method: "POST",
                                    body: JSON.stringify({
                                        marketplace: marketplaceData,
                                    }),
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                });

                                const data = await result.json();

                                if (data.error) {
                                    switch (data.error) {
                                        case "PLACE_NOT_FOUND":
                                            alert("Não foi encontrada loja do seu Bling com esse código!");
                                            break;
                                        case "ALREADY_EXISTS":
                                            alert("Já existe marketplace com esse código!");
                                            break;
                                        case "ERROR_SYNCING":
                                            alert(
                                                `Há categorias conflitantes cadastradas em sua conta bling: ${data.fields.join(
                                                    ", "
                                                )}. Exclua elas e tente novamente.`
                                            );
                                            break;
                                    }
                                } else {
                                    setIntegration({
                                        ...integration,
                                        config2: [...(integration.config2 || []), marketplaceData],
                                    });
                                    setAddMarketplace(false);
                                    setMarketplaceData({ marketplace: 1 });
                                }
                                setAddMarketplaceLoading(false);
                            } catch (err) {
                                console.error(err);
                            }
                        }}
                    >
                        Salvar
                    </div>
                </div>
            </div>

            <div className={`integrations-modal-bg ${modalAdd ? "shown" : ""}`} onClick={() => setModalAdd(false)}>
                <div className="integrations-add-modal" onClick={(ev) => ev.stopPropagation()}>
                    <div className="integration-add-modal-title">Adicionar integração</div>
                    <div
                        className={`integration-add-btn ${integrationsArray.some((e) => e.type == 0) ? "disabled" : ""}`}
                        onClick={(ev) => {
                            ev.preventDefault();
                            setModalAdd(false);
                            setModalWaiting(true);
                            setTimeout(
                                () =>
                                    window.open(
                                        "https://www.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=164ee460d532d449d06c23ae3b5cfe84f0c03d75&state=a12aa8c06358c2efccef0fb84d83fd83&scopes=98309+98310+98313+98314+98565+507943+5990556+106168710+182224097+199272829+220621674+318257570+318257583+333936575+363921591+363953167+363953556+791588404+1649295804+1869535257+5862218180+13645012997+13645013013+13645013025",
                                        //"https://www.bling.com.br/OAuth2/views/authorization.php?response_type=code&client_id=164ee460d532d449d06c23ae3b5cfe84f0c03d75&state=b232d14e318e31fa956a9fc54537997d&scopes=98309+98310+98313+98314+98565+507943+5990556+106168710+182224097+199272829+220621674+318257570+318257583+333936575+363921591+363953167+363953556+791588404+5862218180+13645012997",
                                        "_blank",
                                        "noopener,noreferrer"
                                    ),
                                100
                            );
                            Cookies.set("integration", "false");
                            let interval;
                            interval = setInterval(async () => {
                                if (Cookies.get("integration") === "true") {
                                    clearInterval(interval);
                                    setTimeout(async () => {
                                        setModalWaiting(false);
                                        setBlingConfig(true);
                                    }, 1000);
                                }
                            }, 1000);
                        }}
                    >
                        Bling
                    </div>
                    <div
                        className={`integration-add-btn disabled ${integrationsArray.some((e) => e.type == 1) ? "disabled" : ""}`}
                        onClick={(ev) => {
                            ev.preventDefault();
                            setModalAdd(false);
                            setModalWaiting(true);
                            setTimeout(
                                () =>
                                    window.open(
                                        "https://auth.mercadolivre.com.br/authorization?response_type=code&client_id=22322760717096&redirect_uri=https://orizom.cloud/api/mercadolivre/auth",
                                        "_blank",
                                        "noopener,noreferrer"
                                    ),
                                100
                            );
                            Cookies.set("integrationML", "false");
                            let interval;
                            interval = setInterval(async () => {
                                if (Cookies.get("integrationML") === "true") {
                                    clearInterval(interval);
                                    setTimeout(async () => {
                                        setModalWaiting(false);
                                    }, 1000);
                                }
                            }, 1000);
                        }}
                    >
                        Mercado Livre
                        <div className="em-breve">Em breve!</div>
                    </div>
                </div>
            </div>
            <div className={`integrations-modal-bg ${modalWaiting ? "shown" : ""}`}>
                <div className="integrations-waiting-modal" onClick={(ev) => ev.stopPropagation()}>
                    <div className="integration-add-modal-title">Aguardando conexão...</div>
                    <Loader />
                    <div className="integration-modal-confirm-btn" onClick={() => setModalWaiting(false)}>
                        Cancelar
                    </div>
                </div>
            </div>
            <div className={`integrations-modal-bg ${modalConfirm ? "shown" : ""}`} onClick={() => setModalConfirm(false)}>
                <div className="integrations-confirm-modal" onClick={(ev) => ev.stopPropagation()}>
                    <div className="integration-add-modal-title">Sua integração será removida.</div>
                    <div className="integration-modal-confirm-btns">
                        <div className="integration-modal-confirm-btn" onClick={() => setModalConfirm(false)}>
                            Cancelar
                        </div>
                        <div
                            className="integration-modal-confirm-btn btn-yes"
                            onClick={async () => {
                                await fetch("/api/integrations/remove", {
                                    method: "DELETE",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                        id: modalIntegration.id,
                                    }),
                                });
                                setModalConfirm(false);
                            }}
                        >
                            Ok
                        </div>
                    </div>
                </div>
            </div>
            {integrationsArray ? (
                <div className="integration-container">
                    <div className="add-integration" onClick={() => setModalAdd(true)}>
                        Adicionar integração
                    </div>
                    <div className="integration-container-inside">
                        {integrationsArray.map((integration) => {
                            return (
                                <div className="integration">
                                    <div className={`integration-syncing ${integration.syncing ? "shown" : ""}`}>
                                        <Loader />
                                        <div className="syncing-title">Sincronizando</div>
                                        <div className="syncing-bar">
                                            <div
                                                className="syncing-bar-inner"
                                                style={{
                                                    width: `${
                                                        ((integration?.syncingData?.qtty || 1) /
                                                            (integration?.syncingData?.total || 100)) *
                                                        100
                                                    }%`,
                                                }}
                                            />
                                        </div>
                                        <div className="syncing-qtty">
                                            {integration?.syncingData?.qtty || 0}/{integration?.syncingData?.total || 0} produtos
                                        </div>
                                        <div
                                            className="integration-configuration"
                                            onClick={() => {
                                                setBlingConfig(true);
                                                setIntegration(integration);
                                            }}
                                        >
                                            Configurar
                                        </div>
                                    </div>
                                    <div className="integration-btn">{integrationTypes[integration.type].name}</div>
                                    <div className="integration-detail">
                                        <span>{(integration.data && integration.data.login) || "Usuário"}</span>
                                    </div>
                                    <div
                                        className="integration-configuration"
                                        onClick={() => {
                                            setBlingConfig(true);
                                            setIntegration(integration);
                                        }}
                                    >
                                        Configurar
                                    </div>
                                    <div
                                        className="integration-remove"
                                        onClick={() => {
                                            setModalIntegration(integration);
                                            setModalConfirm(true);
                                        }}
                                    >
                                        Remover
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                ""
            )}
        </>
    );
}
